import { Typography } from "@mui/material";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import React from "react";
import styles from "./LabeledSelect.module.css";

function LabeledSelect({
  data,
  register,
  required,
  name,
  errors,
  placeholder,
  label,
}) {
  return (
    <label className={styles.label} htmlFor="">
      {label && (
        <div className={styles.heading}>
          <Typography>{label}  {required && (
            <span style={{ color: "red" }}>
              *
            </span>
          )}</Typography>
         
        </div>
      )}

      <select {...register(name)} className={styles.select} name={name} id="">
        <option value="">{placeholder}</option>
        {data?.map((item, index) => {
          return (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
      {errors[name] && <ValidationMessage message={errors[name]?.message} />}
    </label>
  );
}

export default LabeledSelect;
